import { useQuery } from '@apollo/client'
import { getFlaggedUserList as getFlaggedUserListGql }
   from 'src/graphql/queries/getFlaggedUserList.gql'

const useFlaggedUserList = (variables, options) => {
   const { data, error, fetchMore, loading, networkStatus, refetch } =
      useQuery(getFlaggedUserListGql, {
         variables,
         fetchPolicy: 'cache-and-network',
         notifyOnNetworkStatusChange: false,
         ...options
      })

   return {
      flaggedUserList: data
         ? data.flaggedUserList
         : { items: [], listInfo: {} },
      error,
      fetchMore,
      loading,
      networkStatus,
      refetch
   }
}

export default useFlaggedUserList
